import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, HostBinding, Inject, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Observable, Subject, map } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { Stats } from "src/app/models/stats.model";


import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";

export let applicationVersionFromHome: string = "";

import { PraticaScuola_Firestore } from "src/app/models/praticaScuolaFirestore.model";
import { onSnapshot } from "firebase/firestore";
import { TabViewChangeEvent } from "primeng/tabview";
import { environment } from "src/environments/environment";
import { PraticaSanita_Firestore } from "src/app/models/praticaSanitaFirestore.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";
import { UtilService } from "src/app/services/util.service";


declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-ko",
  templateUrl: "./home.ko.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeKOFlowdy2Component implements OnInit {
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;

  ref: DynamicDialogRef;



  protected isLoading: boolean = true;
  protected isAdmin:      boolean = false;
  protected isSuperAdmin: boolean = false;
  
  protected isDipendente: boolean = true;
  protected hasBando1: boolean = false;
  protected hasBando2: boolean = false;

  protected praticheBando1KO: PraticaFlowdy2_Firestore[]=[]
  protected praticheBando2KO: PraticaFlowdy2_Firestore[]=[]

  protected selectedPraticaBando1KO: PraticaFlowdy2_Firestore;
  protected selectedPraticaBando2KO: PraticaFlowdy2_Firestore;


  //CSV BOX
  private csvbox_licenseKey_aggiornaPratiche:string=environment.csvBox.secret_aggiornaPratiche;
  private csvbox_licenseKey_aggiornaPraticheBando1:string=environment.csvBox.secret_aggiornaPraticheBando1;
  private csvbox_licenseKey_aggiornaPraticheSanita:string=environment.csvBox.secret_aggiornaPraticheSanita;
  private csvbox_user:string=environment.csvBox.user;
  private csvbox_importer_aggiornaPratiche:any;
  private csvbox_importer_aggiornaPraticheBando1:any;
  private csvbox_importer_aggiornaPraticheSanita:any;

  private collection_pratiche:string  = environment.firebase.collection_pratiche;
  protected stats: StatsFlowdy2 = new StatsFlowdy2();

  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
    private dipendenteService: UtentiService,
    private impreseService: ImpreseService,

    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    public firestore: AngularFirestore,
    private statsService: StatsService,
    public utilService:UtilService,
    
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {
    this.logger.info("[HOME KO] ON INIT");
  }

  openPraticheFase1(bando:number, fase:number){
    //this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase/'+fase]));
  }

  getTipoSedeAbbreviata(tipoSede:string):string{
    if(tipoSede.startsWith("M")){
      return "Mand. "+tipoSede.charAt(tipoSede.length-1);

    }else{
      return "Agg. "+tipoSede.charAt(tipoSede.length-1);
    }
  }

   ngOnChanges(changes: SimpleChanges) {
       
      if (changes['impresa'] && changes['impresa'].currentValue) {
        this.impresa = changes['impresa'].currentValue;
      }
      if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
        this.isImpresa = changes['isImpresa'].currentValue;
      }
      if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
        this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
      }
  
      if( (changes['isImpresa'] && changes['isImpresa'].currentValue) || (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) || (changes['impresa'] && changes['impresa'].currentValue)){
        this.loadDatiBando1();
        this.loadKOTotaliBando1();
        this.loadDatiBando2();
        this.loadKOTotaliBando2();
      }
    }

    loadKOTotaliBando1(){
      this.isLoading = true;
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando1  ;
      if(this.isImpresa){
        queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("sopralluogoOk", "==", false)
                    .where("bando", "==", "BANDO 1")
                    ;
      }else{
        queryBando1 = collectionRef
                      .where("sopralluogoOk", "==", false)
                      .where("bando", "==", "BANDO 1")
                      ;
      }

      onSnapshot(queryBando1, (qs) => {
        this.stats.resetBando1();
        this.isLoading = false;
        this.stats.bando1KO = qs.docs.length;

        qs.forEach((doc) => {
          let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;

          if(praticaBando1DaFirestore.lotto==='6'){
            this.stats.bando1KO_lotto6++;
          }else{
            this.stats.bando1KO_lotto7++;
          }
        });
        
      });
    }
    loadKOTotaliBando2(){
      this.isLoading = true;
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando2  ;
      if(this.isImpresa){
        queryBando2 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("sopralluogoOk", "==", false)
                    .where("bando", "==", "BANDO 2")
                    ;
      }else{
        queryBando2 = collectionRef
                      .where("sopralluogoOk", "==", false)
                      .where("bando", "==", "BANDO 2")
                      ;
      }

      onSnapshot(queryBando2, (qs) => {
        this.stats.resetBando2();
        this.isLoading = false;
        this.stats.bando2KO = qs.docs.length;

        qs.forEach((doc) => {
          let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;

          if(praticaBando2DaFirestore.lotto==='1'){
            this.stats.bando2KO_lotto1++;
          }else if(praticaBando2DaFirestore.lotto==='5'){
            this.stats.bando2KO_lotto5++;
          }else if(praticaBando2DaFirestore.lotto==='7'){
            this.stats.bando2KO_lotto7++;
          }else{
            this.stats.bando2KO_lotto8++;
          }
        });
        
      });
    }
    loadDatiBando1(){
     /*  if(this.isImpresa){
        this.logger.info('[HOME KO] INIZIO CARICAMENTO DATI BANDO 1 PER IMPRESA');
      }else if(this.isPresidioTIM){
        this.logger.info('[HOME KO] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO TIM');
      }else{
        this.logger.info('[HOME KO] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO');
      }  */
      this.isLoading = true;
      
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando1  ;
      if(this.isImpresa){
        queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("sopralluogoOk", "==", false)
                    .where("bando", "==", "BANDO 1")
                    .orderBy("dataUltimaModificaFase1")
                    .limit(5);
      }else{
        queryBando1 = collectionRef
                      .where("sopralluogoOk", "==", false)
                      .where("bando", "==", "BANDO 1")
                      .orderBy("dataUltimaModificaFase1")
                      .limit(5);
      }
      onSnapshot(queryBando1, (qs) => {
        this.isLoading = false;
       
        this.praticheBando1KO = [];
       // this.logger.info('[HOME KO] DATI ARRIVATI PER BANDO 1: '+ qs.docs.length);
          qs.forEach((doc) => {
            let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
            this.praticheBando1KO.push(praticaBando1DaFirestore);
          
              
            
          });
      });
    }

    loadDatiBando2(){
      /* if(this.isImpresa){
        this.logger.info('[HOME KO] INIZIO CARICAMENTO DATI BANDO 2 PER IMPRESA');
      }else if(this.isPresidioTIM){
        this.logger.info('[HOME KO] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO TIM');
      }else{
        this.logger.info('[HOME KO] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO');
      }  */
      this.isLoading = true;
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let queryBando2  ;
      this.praticheBando2KO = [];
      if(this.isImpresa){
        queryBando2 = collectionRef
                      .where("idAzienda", "==", this.userService.getUser().azienda.id)
                      .where("sopralluogoOk", "==", false)
                      
                   //   .where("vincolata", "!=", true)
                    //  .where("dataUltimaModificaFase1", "!=", "null")
                    //  .orderBy("vincolata")
                      .orderBy("dataUltimaModificaFase1")
                    //  .limit(5)
                      ;
        }else{
        queryBando2 = collectionRef
                        .where("sopralluogoOk", "==", false)
                      //  .where("vincolata", "!=", true)
                        .where("bando", "==", "BANDO 2")
                      //    .where("dataUltimaModificaFase1", "!=", "null")

                        .orderBy("dataUltimaModificaFase1")
                     //   .limit(5)
                        ;
      }
      onSnapshot(queryBando2, (qs) => {
        this.isLoading = false;
        this.praticheBando2KO = [];
        let contatore:number = 0;

        qs.forEach((doc) => {
            let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
            if(praticaBando2DaFirestore.dataUltimaModificaFase1 && contatore < 5){
              this.praticheBando2KO.push(praticaBando2DaFirestore);
              contatore++;
            }
             
        }); 
      });
    }
  
  
}
